import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // This ensures the service is available application-wide
})
export class CookieStorageService {
  // Set a cookie
  setItem(key: string, value: string, days?: number): void {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${key}=${value || ''}${expires}; path=/`;
  }

  // Get data from cookies
  getItem(key: string): string | null {
    const nameEQ = `${key}=`;
    const ca = document.cookie.split(';');
    for (const c of ca) {
      // Changed to for-of loop
      let cookie = c;
      while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
      if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length, cookie.length);
    }
    return null;
  }

  // Remove a cookie
  removeItem(key: string): void {
    this.setItem(key, '', -1); // Set the cookie to expire
  }

  // Clear all cookies (use with caution)
  clear(): void {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      // Changed to for-of loop
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      this.removeItem(name);
    }
  }
}
